const NEXT_BUTTON_TEST_ID = "NextButton";
const PREVIOUS_BUTTON_TEST_ID = "PrevButton";
export {
  NEXT_BUTTON_TEST_ID,
  PREVIOUS_BUTTON_TEST_ID
};
